import React from 'react';

function Pill( { children, className } ) {

    return <button className={`px-4 rounded-full border border-blue uppercase ${className}`}>{children}</button>;

}

export default Pill;